const white = "#FFF"
const black = "#000"

export const common = {
  white,
  black,
}
